import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapPin } from 'lucide-react';

import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

export default function CheckoutServiceTypeSection({
  serviceType,
  setServiceType,
  isDemoCheckout,
  business,
  tableNumber,
  setTableNumber,
}) {
  const { t } = useTranslation();
  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-1">{t('checkout.serviceTypeTitle')}</h2>
      <p className="text-sm text-muted-foreground mb-4">{t('checkout.serviceTypeHint')}</p>
      <RadioGroup value={serviceType} onValueChange={setServiceType}>
        {isDemoCheckout ? (
          <>
            <div className="flex items-center space-x-2 p-3 border rounded-lg">
              <RadioGroupItem value="delivery" id="demo-delivery" />
              <Label htmlFor="demo-delivery" className="flex-1 cursor-pointer">
                <MapPin className="w-4 h-4 inline mr-2" />
                {t('checkout.delivery')}
              </Label>
            </div>
            <div className="flex items-center space-x-2 p-3 border rounded-lg">
              <RadioGroupItem value="retiro" id="demo-retiro" />
              <Label htmlFor="demo-retiro" className="flex-1 cursor-pointer">
                {t('checkout.pickup')}
              </Label>
            </div>
          </>
        ) : (
          <>
            {business?.service_types?.includes('delivery') && (
              <div className="flex items-center space-x-2 p-3 border rounded-lg">
                <RadioGroupItem value="delivery" id="delivery" />
                <Label htmlFor="delivery" className="flex-1 cursor-pointer">
                  <MapPin className="w-4 h-4 inline mr-2" />
                  {t('checkout.delivery')}
                </Label>
              </div>
            )}
            {business?.service_types?.includes('retiro') && (
              <div className="flex items-center space-x-2 p-3 border rounded-lg">
                <RadioGroupItem value="retiro" id="retiro" />
                <Label htmlFor="retiro" className="flex-1 cursor-pointer">
                  {t('checkout.pickup')}
                </Label>
              </div>
            )}
          </>
        )}
        {business?.service_types?.includes('mesa') && business?.has_tables && (
          <div className="flex items-center space-x-2 p-3 border rounded-lg">
            <RadioGroupItem value="mesa" id="mesa" />
            <Label htmlFor="mesa" className="flex-1 cursor-pointer">
              {t('checkout.table')}
            </Label>
          </div>
        )}
      </RadioGroup>

      {serviceType === 'mesa' && (
        <div className="mt-4">
          <Label htmlFor="table-number">{t('checkout.tableNumber')}</Label>
          <Input
            id="table-number"
            type="number"
            value={tableNumber}
            onChange={(e) => setTableNumber(e.target.value)}
            placeholder={t('checkout.tablePlaceholder')}
            className="mt-2"
          />
        </div>
      )}
    </Card>
  );
}
